import Card from "./Card";

function HoldingCard({ holding }) {
    const profit = Number(holding.profit || 0);
    const profitRate = Number(holding.profitRate || 0);

    return (
        <Card>
            <div className="holding-header">
                <div>
                    <div className="holding-name">{holding.stockName}</div>
                    <div className="holding-code">{holding.stockCode}</div>
                </div>
                <div className={profit >= 0 ? "profit-badge positive" : "profit-badge negative"}>
                    {profitRate.toFixed(2)}%
                </div>
            </div>
            <div className="holding-grid">
                <div>
                    <div className="holding-label">보유 수량</div>
                    <div className="holding-value">{Number(holding.quantity || 0).toLocaleString()}주</div>
                </div>
                <div>
                    <div className="holding-label">현재가</div>
                    <div className="holding-value">{Number(holding.currentPrice || 0).toLocaleString()}원</div>
                </div>
                <div>
                    <div className="holding-label">평가 손익</div>
                    <div className={profit >= 0 ? "holding-value positive-text" : "holding-value negative-text"}>
                        {profit.toLocaleString()}원
                    </div>
                </div>
            </div>
        </Card>
    );
}

export default HoldingCard;
